import React from "react"
import Header from "./Header"
import NavMobile from "./NavMobile"

const Navigation = () => (
    <>
      <Header />  
      <NavMobile />
    </>
)

export default Navigation